<template>
    <div class="rich-text-container">
        <div v-if="mode === 'edit'">
            <RichText
                v-model="localValue"
                :options="optionsRichText"
                class="custom-richtext"
                :data-bot="dataBot"
            />
        </div>
        <div v-else class="rich-text-html" v-html="localValue" />
    </div>
</template>

<script>
import RichText from 'vcomponents/richtext/RichText.vue';

export default {
    components: {
        RichText,
    },
    props: {
        mode: {
            type: String,
            required: true,
        },
        modelValue: {
            type: String,
            required: false,
            default: '',
        },
        dataBot: {
            type: String,
            required: false,
            default: '',
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            optionsRichText: [
                'Heading',
                'Bold',
                'Italic',
                'Underline',
                'BulletList',
                'OrderedList',
                'TextAlign',
                'Divider',
                'Link',
                'Separator',
            ],
            localValue: window.RedactorPlugins.safeMustache.safeToFront(this.modelValue),
        };
    },
    watch: {
        localValue(value) {
            this.$emit('update:modelValue', value);
        },
    },
};
</script>
<style lang="scss" scoped>
.rich-text {
    min-width: auto;
}
</style>
